import React from 'react'
import LegendDonut from '../../common/LegendDonut'

// Deterministic color palette cycling through brand blues and grays.
const CATEGORY_COLORS = [
    '#266ef1',
    '#1948a3',
    '#a9c9ff',
    '#dee9fe',
    '#21242b',
    '#4d5055',
    '#6a6c71',
    '#999a9d',
    '#babbbd',
    '#e9e9ea'
]

// Donut: share of order value across product categories.
const OrdersByProductCategory = ({ categoryData }) => {
    const items = (categoryData ?? []).map((cat, idx) => ({
        label: cat.subCategoryName.trim(),
        value: cat.orderValuePercentage,
        color: CATEGORY_COLORS[idx % CATEGORY_COLORS.length]
    }))

    return (
        <LegendDonut
            title='Orders by product category'
            subtitle='Share of order value'
            items={items}
        />
    )
}

export default OrdersByProductCategory
